import { render, staticRenderFns } from "./users-list.vue?vue&type=template&id=355bdb9c&scoped=true&"
import script from "./users-list.vue?vue&type=script&lang=js&"
export * from "./users-list.vue?vue&type=script&lang=js&"
import style0 from "./users-list.vue?vue&type=style&index=0&id=355bdb9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355bdb9c",
  null
  
)

export default component.exports